/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var PromotionEntityType;

(function (PromotionEntityType) {
  PromotionEntityType["PROMOTION"] = "promotion";
  PromotionEntityType["PARTNER_PROMOTION"] = "partner_promotion";
  PromotionEntityType["BROKER_PROMOTION"] = "broker_promotion";
})(PromotionEntityType || (PromotionEntityType = {}));